import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "69e5865e-7cc5-4779-86e7-9b2b6ea8afe5",
    content: "The ray tracing method can model the<br>scattering effect.",
    options: {},
  },
  {
    id: "86c81366-0109-4aec-ad43-eead29ab9c01",
    content: "Ray tracing is just valid for low<br>frequencies.",
    options: {},
  },
  {
    id: "5c97a3c0-0698-47bc-85d5-6c3037cf0da8",
    content: "To generate the room impulse response a<br>histogram for each frequency band is<br>required.",
    options: {},
  },
  {
    id: "7ee10d53-9b15-4b45-a525-5f0e66638502",
    content: "Ray tracing belongs to the group of wave-<br>based simulations.",
    options: {},
  },
];

export const task: Task = {
  id: "912dc4b3-4af0-4d91-88fc-1f662d401b3f",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 1,
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["69e5865e-7cc5-4779-86e7-9b2b6ea8afe5", "5c97a3c0-0698-47bc-85d5-6c3037cf0da8"],
};
